
import { defineComponent } from 'vue'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import ProgressBar from 'primevue/progressbar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import MenuConfigurationRelatedDocumentsDescriptor from './MenuManagementRelatedDocumentsDescriptor.json'
import { AxiosResponse } from 'axios'
import { iDocument } from '../MenuManagement'

export default defineComponent({
    name: 'related-documents-list',
    components: {
        DataTable,
        Column,
        ProgressBar
    },
    emits: ['selectedDocument'],
    props: {
        documents: Object,
        loading: Boolean
    },
    watch: {
        loading: {
            handler: function(l) {
                this.load = l
            }
        }
    },
    data() {
        return {
            apiUrl: process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/',
            load: false as Boolean,
            relatedDocumentsList: [] as iDocument[],
            filters: {
                global: [filterDefault],
                DOCUMENT_NAME: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                DOCUMENT_DESCR: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as Object,
            selectedDocument: null as iDocument | null,
            menuConfigurationRelatedDocumentsDescriptor: MenuConfigurationRelatedDocumentsDescriptor
        }
    },
    async created() {
        await this.loadRelatedDocuments()
    },
    methods: {
        async loadRelatedDocuments() {
            this.load = true
            await this.$http
                .get(this.apiUrl + 'documents/listDocument')
                .then((response: AxiosResponse<any>) => {
                    this.relatedDocumentsList = response.data.item
                })
                .finally(() => (this.load = false))
        },
        onDocumentSelect(event: any) {
            this.$emit('selectedDocument', event.data)
        }
    }
})
